import * as React from 'react';

export function isKeyboardEvent(ev: unknown): ev is React.KeyboardEvent {
    if (typeof ev === 'object' && ev !== null) {
        return 'key' in ev && 'keyCode' in ev;
    }

    return false;
}
